import React, { Component } from 'react';
// import PropTypes from 'prop-types'
import axios from 'axios';
import config from '../dummy_data/configuration.json';
import Navigation from '../components/Navigation'
import Breadcrumb from '../components/Breadcrumb'
// import Footer from '../components/Footer'
import SimpleFooter from '../components/SimpleFooter'
import {BreadcrumbItems} from '../dummy_data/localizationItems.json'


class NewsDetail extends Component {

	constructor () {
		super()
		this.state = {
			footerItem: {},
			productLinesItems: [],
			productItem: [],
			showMobileMenu: false
		}
	}

	componentWillMount() {
		// console.log(this.props.match.params.id);
		this._getProductLines();


		if(this.props.match.params.id){
			this._refreshData(this.props.match.params.id);
		}

		this._getFooter();
	}

	handleShowHideMobileMenu(){
		this.setState({
	      showMobileMenu: !this.state.showMobileMenu
	    });
	}

	handleScreenClick(event){
		if(event.target.tagName !== "A" && event.target.className !== "fa fa-bars" && event.target.className !== "navigation-folded" && event.target.offsetParent.className.indexOf("mobile") < 0){
			this.setState({
		      showMobileMenu: false
		    });
		}
	}

	_refreshData = (id) => {
		axios({
	        method: 'GET',
	        url: `${config.productsAction}/${id}`,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            console.log(res);
            this.setState({
            	productItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_getProductLines = () => {
		axios({
	        method: 'GET',
	        url: config.productLinesAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            this.setState({
            	productLinesItems: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_buildLocation = () => {
		const location = [];
		location.push({
			name: localStorage.getItem("isEnglish") === "true"? BreadcrumbItems.find(i => i.fieldName === "Products").eName : BreadcrumbItems.find(i => i.fieldName === "Products").name,
			url: "/products/All"
		});
		location.push({
			name: this._mapProdType(this.state.productItem.Category),
			url: `/products/${this.state.productItem.Category}`
		});
		location.push({
			name: this.state.productItem.Name,
			url: this.props.match.url
		});

		// console.log(this.props);

		return location;
	}

	_mapProdType = (type) => {
		// if(type === 'EMERSON'){
		// 	return '防爆灯具及电器产品'
		// }
		// else if(type === 'UNISTRUT'){
		// 	return '电缆托架产品'
		// }
		// else if(type === 'LEONI'){
		// 	return '仪表及动力电缆'
		// }
		// else if(type === 'HEADHUNTER'){
		// 	return '生活污水处理装置'
		// }
		// else if(type === 'LiquidControl'){
		// 	return '流量计及罐区自动化产品'
		// }
		// else if(type === 'Autocontrol'){
		// 	return '自动取样设备'
		// }

		let target = this.state.productLinesItems.find(pl => pl.ID == type);
		if(target){
			return target.Name;
		}

		return '';
	}

	_getFooter = () => {
		axios({
	        method: 'GET',
	        url: config.footerAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	footerItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}


	render() {
		const location = this._buildLocation();
		let parentList = {}
		if(location.length > 2){
			parentList = `#${location[location.length - 2].url}`;
		}
		return(
			<div onClick={this.handleScreenClick.bind(this)}>
				<Navigation showMobileMenu={ this.state.showMobileMenu } handleShowHideMobileMenu={ this.handleShowHideMobileMenu.bind(this)}/>
				<div className="banner"><img src={require("../img/news.jpg")} alt="" /></div>
				<div className="content-container">
					<Breadcrumb location={location} />
					<div className="product-detail">
						<div className="product-detail-info">
							<div className="product-image">
								<img src={config.rootSite + this.state.productItem.Image} alt={this.state.productItem.Name} />
							</div>
							<div className="product-info">
								<h1>{this.state.productItem.Name}</h1>
								{/*<div className="product-properties">
									<div><b>【产品类目:】</b><span><a href={`#/products/${this.state.productItem.Category}`}>{this.state.productItem.Category}</a></span></div>
									<div><b>【发布日期:】</b><span>{this.state.productItem.Created}</span></div>
								</div>*/}
								<span>特点：{this.state.productItem.Trait}</span>
								<div className="product-info-contact">服务热线：<em>{this.state.footerItem.PhoneNumber1}</em></div>
							</div>
						</div>
						
						<div className="product-description">
							<div className="product-description-title" style={{"backgroundImage": `url(${require('../img/cansu_line.gif')})`}}>产品介绍</div>
							<div className="product-description-content" dangerouslySetInnerHTML={{__html: this.state.productItem.Description}}></div>
						</div>
					</div>
				</div>
				{/*<Footer item={this.state.footerItem} />*/}
				<SimpleFooter item={this.state.footerItem} />
			</div>
		)
	}
}

export default NewsDetail;


// WEBPACK FOOTER //
// ./src/pages/ProductDetail.js